var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment row"},[(_vm.paymentUrl)?_c('iframe',{attrs:{"src":_vm.paymentUrl,"frameBorder":"0","id":"paymentFrame"}}):_c('div',{staticClass:"col-12 my-3 text-center"},[_vm._v("\n        Oops something went wrong, please try again\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }